import { render, staticRenderFns } from "./PerformanceAccordion.vue?vue&type=template&id=c9597f9e&scoped=true"
import script from "./PerformanceAccordion.vue?vue&type=script&lang=js"
export * from "./PerformanceAccordion.vue?vue&type=script&lang=js"
import style0 from "./PerformanceAccordion.vue?vue&type=style&index=0&id=c9597f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9597f9e",
  null
  
)

export default component.exports